module.exports = __webpack_public_path__ + "static/Hindenburgpark-7be175867357913cf592a809667662ff.png";